import { Ticket } from '../../../types/ticket';

type EventLike = {
  attributes?: {
    faceRecognition?: { value?: boolean };
  };
};

export const anyGroupHasFaceRecognition = (tickets: Ticket[]): boolean => {
  return tickets.some((ticket) => ticket.faceRecognition);
};

export const shouldFetchFacialRecognitionUrl = ({
  event,
  groupHasFaceRecognition,
}: {
  event: EventLike | null | undefined;
  groupHasFaceRecognition: boolean;
}): boolean => {
  const eventHasFaceRecognition = Boolean(event?.attributes?.faceRecognition?.value);
  return eventHasFaceRecognition && groupHasFaceRecognition;
};

export const canSkipFacialRecognitionFetch = ({
  userHasBiometry,
  rfData,
}: {
  userHasBiometry: boolean;
  rfData: unknown;
}): boolean => {
  return userHasBiometry && rfData !== null && rfData !== undefined;
};
